import type { Resource } from '../../';
export const country_countries_JP: Resource = {"default":"Japan"};
